import { TransferBaseModel } from "../transfer-base.model";

export interface Lookup extends TransferBaseModel {
    id?: string;
    code?: string;
    name?: string;
}